import { createContext } from 'react';

export const AuthContext = createContext();
export const LoaderContext = createContext();
export const CountriesContext = createContext();
export const CompanyContext = createContext();
export const SelectedCompanyContext = createContext();
